import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'

function countUp(el){
    let target = parseFloat(el.data('num'));
    $({count:0}).animate(
        {count:target},
        {
            duration:2000,
            step:function(now){
                el.text(Math.floor(now));
            },
            complete:function(){
                el.text(target);
            }
        }
    );
}

let played1 = false;
$(window).on('scroll',function(){
    let top = $('.section1 .stats').offset().top;
    let winTop = $(window).scrollTop();
    let winH = $(window).height();
    if(!played1 && winTop + winH > top){
        played1 = true;
        $('.section1 .item').each(function(index){
            let _this = $(this);
            setTimeout(function(){
                _this.addClass('show');
                countUp(
                    _this.find('.num')
                );
            },index * 250);
        });
    }
}).trigger('scroll');

let played2 = false;
$(window).on('scroll',function(){
    let top = $('.section5 .stats').offset().top;
    let winTop = $(window).scrollTop();
    let winH = $(window).height();
    if(!played2 && winTop + winH > top){
        played2 = true;
        $('.section5 .item').each(function(index){
            let _this = $(this);
            setTimeout(function(){
                _this.addClass('show');
                countUp(
                    _this.find('.num')
                );
            },index * 250);
        });
    }
}).trigger('scroll');


var swiperLeft = new Swiper(".swiper-left", {
    loop:true,
    speed:4000,//匀速时间
    autoplay: {
    	delay: 0,
    	stopOnLastSlide: false,
    	disableOnInteraction: false,
    },
    breakpoints: {
        768: {  //当屏幕宽度小于等于768
            slidesPerView: 3.36,
            spaceBetween: 24,
        },
        320: {  //当屏幕宽度小于等于320
            slidesPerView: 1.3,
            spaceBetween: 10, 
        }
    }  
}); 
var swiperRight = new Swiper(".swiper-right", {
    loop:true,
    speed:7000,//匀速时间
    autoplay: {
    	delay: 0,
    	stopOnLastSlide: false,
    	disableOnInteraction: false,
        reverseDirection: true,
    },
    breakpoints: {
        768: {  //当屏幕宽度小于等于768
            slidesPerView: 3.36,
            spaceBetween: 24,
        },
        320: {  //当屏幕宽度小于等于320
            slidesPerView: 1.3,
            spaceBetween: 10, 
        }
    }  
}); 

var advancedSwiper = new Swiper(".section4 .swiper", {
    centeredSlides: true,
    loop: true,
    navigation: {
        nextEl: ".section4 .swiper-button-next",
        prevEl: ".section4 .swiper-button-prev",
    },
    speed:500,
    breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 1.66,
        spaceBetween: 31,
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 1,
        spaceBetween: 0,
      }
    } 
});